<nav class="app-navbar" role="navigation" [hidden]="isHidden">
  <div class="app-navbar__inner">
    <div class="app-navbar__header">
      <button
        type="button"
        class="app-navbar__toggle"
        [attr.aria-expanded]="menuOpen"
        aria-controls="app-navbar"
        aria-label="Toggle navigation"
        (click)="toggleMenu()"
      >
      <app-cmn-icon [name]="CmnIconName.ChevronDown"></app-cmn-icon>
      </button>
    </div>
    <div class="app-navbar__menu" [class.app-navbar__menu--open]="menuOpen" id="app-navbar">
      <ul class="app-navbar__items">
        @for (item of menuItems; track item.route) {
          <li
            class="app-navbar__item"
            [class.is-active]="isMenuItemActive(item.route)"
            (click)="item.action()"
          >
            <a class="title" [title]="item.hover">
              <app-cmn-icon [name]="item.icon"></app-cmn-icon>
              {{ item.title }}
            </a>
          </li>
        }
      </ul>
    </div>
  </div>
</nav>
